import { render } from "./ConsultLicenseView.vue?vue&type=template&id=ec165e48&scoped=true"
import script from "./ConsultLicenseView.vue?vue&type=script&lang=js"
export * from "./ConsultLicenseView.vue?vue&type=script&lang=js"

import "./ConsultLicenseView.vue?vue&type=style&index=0&id=ec165e48&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec165e48"]])

export default __exports__